import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faDownload, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-simulation-model-io',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, NgSelectModule, TranslateModule],
  templateUrl: './simulation-model-io.component.html',
  styleUrls: ['./simulation-model-io.component.scss'],
})
export class SimulationModelIoComponent {
  @Input() models: any[] = [];
  @Input() selectedModel: string | null = null;
  @Input() labelKey = 'INTERACTION_MODEL_EDITOR.MODEL_LABEL';
  @Input() placeholderKey = 'INTERACTION_MODEL_EDITOR.SELECT_MODEL';
  @Input() showDelete = false;
  @Input() importDisabled = false;
  @Input() exportDisabled = false;

  @Output() selectedModelChange = new EventEmitter<string | null>();
  @Output() importModel = new EventEmitter<void>();
  @Output() exportModel = new EventEmitter<void>();
  @Output() deleteModel = new EventEmitter<string>();

  readonly icons = { faCheck, faDownload, faTrash, faUpload };

  onDelete(item: any, event: Event): void {
    event.stopPropagation();
    if (item?.id != null) this.deleteModel.emit(String(item.id));
  }
}
